import Component from '../components/Component'

export default class Block extends Component {}
